import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaPlane, FaHotel, FaBus } from "react-icons/fa";

const TABS = [
  { name: "flight", label: "Flights", icon: FaPlane },
  { name: "hotel", label: "Hotels", icon: FaHotel },
  { name: "bus", label: "Bus", icon: FaBus },
];

const TravelTabs = ({ activeTab, setActiveTab }) => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromURL = params.get("tab");
    if (tabFromURL) setActiveTab(tabFromURL);
  }, [location.search, setActiveTab]);

  return (
    <div className="flex gap-1 sm:gap-2 bg-white border border-ink-100 rounded-2xl p-1.5 w-full sm:w-fit mx-auto sm:mx-0">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.name;
        return (
          <button
            key={tab.name}
            onClick={() => setActiveTab(tab.name)}
            className={`flex-1 sm:flex-none flex items-center justify-center gap-2 px-5 sm:px-7 py-3 rounded-xl text-[15px] font-bold transition-all duration-200 ${
              isActive
                ? "bg-brand-600 text-white shadow-[0_1px_2px_rgba(0,0,0,0.08)]"
                : "text-ink-600 hover:bg-ink-50"
            }`}
          >
            <Icon size={15} />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default TravelTabs;
